export default __webpack_public_path__ + "static/media/location-icon.05286d7a.svg";